export const REGION_AFRICA = 'Africa';
export const REGION_ASIA = 'Asia';
export const REGION_EUROPE = 'Europe';

/** Curated agent travel products (Pacis / Mapfre simple codes). */
export const TRAVEL_AGENT_PRODUCTS = [
  {
    label: 'Africa — Individual', prodCode: 'AFR_IND', region: REGION_AFRICA, zone: '1', planType: 'individual',
  },
  {
    label: 'Africa — Family', prodCode: 'AFR_FAM', region: REGION_AFRICA, zone: '1', planType: 'family',
  },
  {
    label: 'Asia — Individual', prodCode: 'ASI_IND', region: REGION_ASIA, zone: '12', planType: 'individual',
  },
  {
    label: 'Asia — Family', prodCode: 'ASI_FAM', region: REGION_ASIA, zone: '12', planType: 'family',
  },
  {
    label: 'Europe Basic — Individual', prodCode: 'EUR_BAS', region: REGION_EUROPE, zone: '2', planType: 'individual',
  },
  // {
  //   label: 'Europe Basic — Family', prodCode: 'EUR_FAM_BAS', region: REGION_EUROPE, zone: '2', planType: 'family',
  // },
  {
    label: 'Europe Plus — Individual', prodCode: 'EUR_IND_PLU', region: REGION_EUROPE, zone: '2', planType: 'individual',
  },
  // {
  //   label: 'Europe Plus — Family', prodCode: 'EUR_FAM_PLU', region: REGION_EUROPE, zone: '2', planType: 'family',
  // },
  {
    label: 'Worldwide Basic — Individual', prodCode: 'WW_IND_BAS', region: 'Worldwide Basic', zone: '3', planType: 'individual',
  },
  {
    label: 'Worldwide Basic — Family', prodCode: 'WW_FAM_BAS', region: 'Worldwide Basic', zone: '3', planType: 'family',
  },
  {
    label: 'Worldwide Premium — Individual', prodCode: 'WW_IND_PRE', region: 'Worldwide Premium', zone: '3', planType: 'individual',
  },
  {
    label: 'Worldwide Premium — Family', prodCode: 'WW_FAM_PRE', region: 'Worldwide Premium', zone: '3', planType: 'family',
  },
];

export const DEFAULT_USD_TO_KSH = 130;

export const ZONE_LABELS = {
  1: '01 — Africa',
  2: '02 — Europe + Schengen',
  12: '12 — Asia',
  3: '03 — Worldwide',
};

export function getDefaultCoverageLimits(prodCode) {
  const base = {
    deliveryOfMedicines: '1',
    emergencyDentalCare: '1',
    assistanceServices24Hours: '1',
    baggageDelayCompensation: '1',
  };
  if (prodCode && prodCode.startsWith('EUR_')) {
    return {
      ...base,
      winterSport: '1',
      hospitalization: '1',
      medicalTransportation: '1',
      personalAssistance: '1',
      accidentalDamagePhoneGadget: '1',
      curtailment: '1',
      baggage: '1',
      travelDelay: '1',
    };
  }
  return base;
}

export function findTravelProduct(prodCode) {
  return TRAVEL_AGENT_PRODUCTS.find((p) => p.prodCode === prodCode) || null;
}
